import { useMutation } from '@apollo/client';
import { NotificationPreferences } from '@bakerweb/models';
import { toast } from 'react-toastify';
import { CREATE_USER_MUTATION } from '../graphql/mutations/createUser';
import { GET_USERS } from '../graphql/queries/getUsers';

export interface CreateUser {
  email: string;
  portfolioCodes: string[];
  accounts: { id: string }[];
  notificationPreferences: Partial<Omit<NotificationPreferences, 'email'>>;
  permissions: {
    pledging: boolean;
    pledgeAndRelease: boolean;
    apm: boolean;
    files: boolean;
    cds: boolean;
    muniCredit: boolean;
    houstonTrust: boolean;
  };
}

export const useCreateUser = () => {
  const [createUserMutation, { data, loading, error }] = useMutation(CREATE_USER_MUTATION, {
    refetchQueries: [{ query: GET_USERS }]
  });

  const createUser = async ({ email, portfolioCodes, accounts, notificationPreferences, permissions }: CreateUser) => {
    const variables = {
      userCreateDto: {
        email,
        portfolioCodes,
        accounts,
        notificationPreferences,
        permissions
      }
    };

    try {
      await createUserMutation({ variables });
      toast.success('User created successfully!');
      return { error: false };
    } catch (error) {
      toast.error(`There was an error creating the user: ${(error as Error).message}`);
      return { error: true };
    }
  };

  return { createUser, data, loading, error };
};
